import { render, staticRenderFns } from "./header-region-picker.vue?vue&type=template&id=0203cad6&scoped=true&"
import script from "./header-region-picker.vue?vue&type=script&lang=js&"
export * from "./header-region-picker.vue?vue&type=script&lang=js&"
import style0 from "./header-region-picker.vue?vue&type=style&index=0&id=0203cad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0203cad6",
  null
  
)

export default component.exports